export const settings = {
    "title": "Residenze Smart",

    /** Identita mostrata nell'header e nelle pagine di accesso: il nome
        in grande, la descrizione sotto. Non ripeterli uguali, o la testata
        dice la stessa cosa due volte. */
    "brand": {
        "name": "Residenze Smart",
        "tagline": "Piattaforma prenotazioni"
    },

    "apiUrl": "https://residenzesmart.gruppoyec.it/api",
    "ckdPath": "https://residenzesmart.gruppoyec.it/",
    "config": {
        /* Quante righe per viaggio. Gli elenchi scaricano tutte le pagine, non
           solo la prima: alzarlo non cambia cosa si vede, riduce i viaggi. */
        "limit": 250,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "mail": '',
    "googleMapKey": '',

    /** Parametri funzionali del progetto (sovrascrivibili da entità `impostazione` lato backend) */
    "booking": {
        /** Finestra di apertura del calendario, in giorni */
        "windowDays": 60,
        /** Orari di apertura della sala */
        "openingTime": "08:00",
        "closingTime": "23:00",
        /** Durata dello slot base, in ore */
        "slotHours": 4,
        /** Anticipo minimo per prenotare, in ore */
        "minAdvanceHours": 24,
        /** Preavviso minimo per annullare senza addebito, in ore */
        "cancelDeadlineHours": 48
    }
}
